import { createFileRoute } from '@tanstack/react-router'
import LaborContractGeneration from '@/features/labor-contract-generation'

export const Route = createFileRoute('/_authenticated/labor-contract-generation')({
  component: LaborContractGeneration,
}) 